<div class="file-attachment-container">
  <label class="field-label">{{ restrictedFileType }} type restrictions</label>
  <div class="file-type-input-container">
    <app-document-type-picker
      #typePicker
      [namespace]="namespace"
      [entityType]="_entityTypes"
      [autoSelectOnExactMatch]="false"
      [position]="'fixed'"
      [clearOnSelection]="true"
      [maxHeight]="documentTypePickerHeight"
      [scrollOnOptionsChange]="false"
      [valid]="valid"
      [disabled]="disabled"
      (selected)="onSelected($event)"
      [matTooltip]="!valid ? 'At least one ' + outputFileType + ' type must be selected.' : ''"
      [matTooltipPosition]="'right'"
      [matTooltipShowDelay]="500"
      [focusInputOnLoad]="false"
      [expandUp]="expandUp"
    ></app-document-type-picker>
    @if (!typePicker.validSelection) {
      <mat-icon
        class="invalid-input-warning"
        fontIcon="error_outlined"
        matTooltip="{{ restrictedFileType }} type not found"
        matTooltipPosition="above"
        matTooltipShowDelay="300"
      ></mat-icon>
    }
  </div>

  @if (loadingDocumentTemplates) {
    <span style="font-size: 16px; margin-left: 8px; color: white">
      {{ loadingDocumentTemplates }}
    </span>
  } @else {
    <div class="chips-container inline-chips">
      @for (documentType of documentTypes; track documentType) {
        <button class="chip">
          {{ documentType.label }}
          <mat-icon
            fontIcon="close"
            class="remove-chip"
            matTooltip="Remove {{ documentType.label }}"
            matTooltipShowDelay="500"
            (click)="onRemove(documentType)"
          ></mat-icon>
        </button>
      }
    </div>
  }

</div>
